import { CheckCircle2, Circle, PauseCircle } from "lucide-react";
import { TAREFA_STATUS_LABELS } from "@/services/tarefas";

const LEGEND = [
  {
    label: TAREFA_STATUS_LABELS.concluida,
    hint: "Tarefa finalizada",
    icon: <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500" />,
  },
  {
    label: TAREFA_STATUS_LABELS.em_andamento,
    hint: "Tarefa em progresso",
    icon: <span className="h-2 w-2 rounded-full bg-blue-500" />,
  },
  {
    label: TAREFA_STATUS_LABELS.parada,
    hint: "Tarefa aguardando",
    icon: <PauseCircle className="h-3.5 w-3.5 text-amber-500" />,
  },
  {
    label: TAREFA_STATUS_LABELS.pendente,
    hint: "Tarefa não iniciada",
    icon: <Circle className="h-3.5 w-3.5 text-slate-300" />,
  },
] as const;

export function TarefasLegenda() {
  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-x-6 gap-y-2 border-t border-slate-200 bg-white px-5 py-3">
      {LEGEND.map((item) => (
        <div key={item.label} className="flex items-center gap-2 text-xs text-slate-500">
          {item.icon}
          <span className="font-medium text-slate-600">{item.label}</span>
          <span className="hidden sm:inline">— {item.hint}</span>
        </div>
      ))}
    </div>
  );
}
